import React from 'react';
import { InputNumber, Select, Text, Button } from '@clockout-dev/design-elements';
import { PlusCircleOutlined } from '@ant-design/icons';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import AdvanceCapTenureRuleRow from './AdvanceCapTenureRuleRow';
import { ADVANCE_TIMEFRAME_OPTIONS } from '../limitsForm.constants';
import styles from '../styles/limitsForm.module.scss';

function AdvanceCapCard({
    value,
    timeframe,
    enabled,
    onChange,
    onChangeTimeframe,
    onToggleEnabled,
    tenureRules = [],
    onAddTenureRule,
    onRemoveTenureRule,
    onUpdateTenureRule
}) {
    return (
        <ConfigurationCard
            title="Advance Cap"
            description="The maximum number of advances a user can make in your selected timeframe"
            togglePosition="leading"
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <div className={styles.cardInputRow}>
                <InputNumber
                    value={value}
                    onChange={onChange}
                    min={0}
                    max={999}
                    step={1}
                    precision={0}
                    controls={false}
                    className={`${styles.inlineNumberInput} ${styles.countField}`}
                />
                <Text as="span" size="s" className={styles.ruleLabel}>Advances per</Text>
                <Select
                    size="large"
                    value={timeframe}
                    options={ADVANCE_TIMEFRAME_OPTIONS}
                    onChange={onChangeTimeframe}
                    className={`${styles.select} ${styles.selectSm}`}
                />
            </div>

            {/* Tenure-based rules section */}
            {tenureRules && tenureRules.length > 0 && (
                <div className={styles.tenureSection}>
                    <Text as="span" size="s" className={styles.panelBlockTitle}>
                        Tenure-Based Adjustments
                    </Text>
                    {tenureRules.map((rule) => (
                        <AdvanceCapTenureRuleRow
                            key={rule.id}
                            rule={rule}
                            onUpdate={onUpdateTenureRule}
                            onRemove={onRemoveTenureRule}
                        />
                    ))}
                </div>
            )}

            {onAddTenureRule && (
                <Button
                    type="button"
                    size="s"
                    variant="text"
                    className={styles.addRowButton}
                    onClick={onAddTenureRule}
                >
                    <PlusCircleOutlined />
                    Add tenure rule
                </Button>
            )}
        </ConfigurationCard>
    );
}

export default AdvanceCapCard;
